export default __webpack_public_path__ + "static/media/ba.48c19236.svg";